import { bool, func, node } from 'prop-types'

/**
 * Conditionally renders a wrapper component based on a `condition` and a `depth`.
 * If the `condition` is `true` (and `depth` too), the children are enclosed within
 * the wrapper component, otherwise they are rendered without it.
 * Depth is forced to `true` when not needed.
 * @example
 * <ConditionalWrapper
 * 	condition={condition}
 * 	depth={true}
 * 	wrapper={(children) => <wrapper>{children}</wrapper>}
 * >
 * 	<children/>
 * </ConditionalWrapper>
 */
const ConditionalWrapper = ({ children, condition, depth, wrapper }) => {
	return condition ? (depth ? wrapper(children) : null) : children
}

ConditionalWrapper.defaultProps = {
	depth: true,
}

ConditionalWrapper.propTypes = {
	/**
	 * The React.Node children that to wrap
	 */
	children: node.isRequired,
	/**
	 * Condition for which wrapping children
	 * @example
	 * !!(props.ctaHref && props.ctaHref !== "#")
	 */
	condition: bool.isRequired,
	/**
	 * Another condition for which wrapping children
	 * This is useful in case there are some APIs to be wait for, besides the condition
	 * @example
	 * ctaHref !== ""
	 * @defaultValue `true`
	 */
	depth: bool,
	/**
	 * The React.Node wrapper
	 */
	wrapper: func.isRequired,
}

export default ConditionalWrapper
